import { apiClient } from '@lib/api-client'
import type { ProfileData, UpdateProfileDto, SessionItem } from '../types'

export const profileService = {
  async getProfile(): Promise<ProfileData> {
    const { data } = await apiClient.get<ProfileData>('/auth/profile', {
      withCredentials: true,
    })
    return data
  },

  async updateProfile(dto: UpdateProfileDto): Promise<ProfileData> {
    const { data } = await apiClient.patch<ProfileData>('/auth/profile', dto, {
      withCredentials: true,
    })
    return data
  },

  async getSessions(): Promise<SessionItem[]> {
    const { data } = await apiClient.get<SessionItem[]>('/auth/sessions', {
      withCredentials: true,
    })
    return data
  },

  async revokeSession(sessionId: string): Promise<void> {
    await apiClient.delete(`/auth/sessions/${sessionId}`, {
      withCredentials: true,
    })
  },
}
